var _excluded = ["actions", "children", "className", "disableGutters", "fixed", "maxWidth", "subtitle", "supertitle", "title"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Container, styled } from '@mui/material';
import clsx from 'clsx';
import { Typography } from '../Typography';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled('div', {
  name: 'MnrlPage',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.root];
  }
})(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.palette.background["default"],
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: 'inherit'
  };
});
var Main = styled('main', {
  name: 'MnrlPage',
  slot: 'Main',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.main];
  }
})({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto'
});
var Header = styled(Container, {
  name: 'MnrlPage',
  slot: 'Header',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.header];
  }
})(function (_ref2) {
  var disableGutters = _ref2.ownerState.disableGutters,
      theme = _ref2.theme;
  return _extends({
    display: 'grid',
    columnGap: theme.spacing(2),
    gridTemplateColumns: '1fr minmax(min-content, max-content)',
    gridTemplateRows: 'repeat(3, min-content)'
  }, !disableGutters && {
    paddingTop: theme.spacing(3)
  });
});
var SuperTitle = styled(Typography, {
  name: 'MnrlPage',
  slot: 'Supertitle',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.supertitle];
  }
})(function (_ref3) {
  var theme = _ref3.theme;
  return {
    gridColumnStart: 1,
    gridRowStart: 1,
    marginBottom: theme.spacing(1)
  };
});
var Title = styled(Typography, {
  name: 'MnrlPage',
  slot: 'Title',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.title];
  }
})({
  gridColumnStart: 1,
  gridRowStart: 2
});
var SubTitle = styled(Typography, {
  name: 'MnrlPage',
  slot: 'Subtitle',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.subtitle];
  }
})({
  gridColumnStart: 1,
  gridRowStart: 3,
  marginBottom: 34 / 2 // 34 = theme.typography.h1.fontSize, but TypeScript thinks I can't reliably access that?

});
var Actions = styled('div', {
  name: 'MnrlPage',
  slot: 'Actions',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.actions];
  }
})({
  gridColumnStart: 2,
  gridRowStart: 2
});
var Content = styled(Container, {
  name: 'MnrlPage',
  slot: 'Content',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.content];
  }
})(function (_ref4) {
  var disableGutters = _ref4.ownerState.disableGutters,
      theme = _ref4.theme;
  return _extends({
    flex: '1 1 auto'
  }, !disableGutters && {
    paddingBottom: theme.spacing(10)
  });
});
export var Page = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var actions = _ref5.actions,
      _ref5$children = _ref5.children,
      children = _ref5$children === void 0 ? /*#__PURE__*/_jsx(_Fragment, {}) : _ref5$children,
      className = _ref5.className,
      disableGutters = _ref5.disableGutters,
      fixed = _ref5.fixed,
      _ref5$maxWidth = _ref5.maxWidth,
      maxWidth = _ref5$maxWidth === void 0 ? false : _ref5$maxWidth,
      subtitleProp = _ref5.subtitle,
      supertitleProp = _ref5.supertitle,
      titleProp = _ref5.title,
      restProps = _objectWithoutPropertiesLoose(_ref5, _excluded);

  var containerProps = {
    disableGutters: disableGutters,
    fixed: fixed,
    maxWidth: maxWidth
  };
  var ownerState = {
    disableGutters: disableGutters
  };
  var subtitle = typeof subtitleProp === 'string' ? /*#__PURE__*/_jsx(SubTitle, {
    className: "MnrlPage-subtitle",
    color: "text.secondary",
    children: subtitleProp
  }) : subtitleProp;
  var supertitle = typeof supertitleProp === 'string' ? /*#__PURE__*/_jsx(SuperTitle, {
    className: "MnrlPage-supertitle",
    variant: "caption",
    color: "text.secondary",
    children: supertitleProp
  }) : supertitleProp;
  var title = typeof titleProp === 'string' ? /*#__PURE__*/_jsx(Title, _extends({
    className: "MnrlPage-title",
    variant: "h1"
  }, !subtitle ? {
    gutterBottom: true
  } : undefined, {
    children: titleProp
  })) : titleProp;
  return /*#__PURE__*/_jsx(Root, _extends({
    className: clsx('MnrlPage-root', className)
  }, restProps, {
    ref: ref,
    children: /*#__PURE__*/_jsxs(Main, {
      className: "MnrlPage-main",
      children: [/*#__PURE__*/_jsxs(Header, _extends({
        className: "MnrlPage-header" // @ts-ignore component prop
        ,
        component: "header",
        ownerState: ownerState
      }, containerProps, {
        children: [supertitle, title, subtitle, actions && /*#__PURE__*/_jsx(Actions, {
          className: "MnrlPage-actions",
          children: actions
        })]
      })), /*#__PURE__*/_jsx(Content, _extends({
        className: "MnrlPage-content",
        ownerState: ownerState
      }, containerProps, {
        children: children
      }))]
    })
  }));
});